import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugRevision
{
    public constructor(
        public action: DrugRevision.Action,
        public authorName: string,
        public institution: string,
        public email: string,
        public date: Date,
        public comments: string[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugRevision
    {
        return new this(
            elem.firstChildByTag("revisionAction").enumValue(DrugRevision.Action),
            elem.firstChildByTag("revisionAuthorName").value(),
            elem.firstChildByTag("institution").value(),
            elem.firstChildByTag("email").value(),
            elem.firstChildByTag("date").valueAsDate(),
            elem.firstChildByTag("comments").translatedElemValues("comment"),
        );
    }
}

export namespace DrugRevision
{
    export enum Action {
        CREATION = "creation",
        MODIFICATION = "modification",
        REVIEW = "review",
        VALIDATION = "validation",
    }
}
